/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useState } from 'react';
import { Popover } from '../Popover/Popover';
import { PopoverListButton } from './PopoverListButton';
import { defaultTo } from '@utils/lodash';

export namespace PopoverList {
  export type SingleSection = PopoverListButton.Props[];

  export interface Props {
    anchorPosition?: Popover.Props['anchorPosition'];
    buttonConfigs: SingleSection;
    children: React.ReactElement;
  }
  export interface State {
    popoverIsOpen: boolean;
  }
}

export const PopoverList: React.FC<PopoverList.Props> = ({ children, anchorPosition, buttonConfigs }) => {
  const [popoverIsOpen, setPopoverIsOpen] = useState(false);

  const togglePopover = () => {
    setPopoverIsOpen(!popoverIsOpen);
  };

  const closePopover = () => setPopoverIsOpen(false);

  const onButtonClick = (e: React.SyntheticEvent) => {
    setPopoverIsOpen(!popoverIsOpen);
    children.props.onClick && children.props.onClick(e);
  };

  const renderSection = (sectionButtonConfigs: PopoverList.SingleSection) => {
    return sectionButtonConfigs.map(buttonConfig => {
      const { onClick, ...PopoverListButtonProps } = buttonConfig;
      return (
        <PopoverListButton
          {...PopoverListButtonProps}
          key={buttonConfig.name}
          onClick={(e: React.SyntheticEvent) => {
            togglePopover();
            onClick && onClick(e);
          }}
        />
      );
    });
  };

  const renderPopoverContent = () => {
    return <div>{renderSection(buttonConfigs)}</div>;
  };

  return (
    <Popover
      data-it="Popover"
      anchorPosition={defaultTo(anchorPosition, 'bottom-end')}
      onClose={closePopover}
      isOpen={popoverIsOpen}
      popoverContent={renderPopoverContent()}
    >
      {React.cloneElement(children, { onClick: onButtonClick })}
    </Popover>
  );
};
